import {
  Component,
  EventEmitter,
  Output,
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Input, OnInit, HostListener, SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Logger } from '@app/core';

const log = new Logger('GooglePlacesAutocompleteComponent');

@Component({
  selector: 'app-google-places-autocomplete',
  standalone: true,
  templateUrl: './google-places-autocomplete.component.html',
  styleUrls: ['./google-places-autocomplete.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, CommonModule],
})

export class GooglePlacesAutocompleteComponent implements OnInit {
  searchQuery: string = '';
  predictions: google.maps.places.AutocompletePrediction[] = [];

  @Output() placeSelected = new EventEmitter<{
    name: string;
    lat: number;
    lng: number;
    fullAddress?: string;
    address_components: [];
  }>();

  @Input() countryCode!: string;
  @Input() placeTypes: string[] = [];
  @Input() initialValue: string;
  protected hasSelectedPlace = false;
  private autocompleteService:any;
  private placesService: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialValue && changes.initialValue.currentValue !== undefined) {
      this.searchQuery = changes.initialValue.currentValue;
      this.hasSelectedPlace = !!changes.initialValue.currentValue;
    }
  }

  async ngOnInit(): Promise<void> {
    this.searchQuery = this.initialValue ? this.initialValue : '';
    await google.maps.importLibrary('places');
    this.autocompleteService = new google.maps.places.AutocompleteService();
    const dummyDiv = document.createElement('div');
    this.placesService = new google.maps.places.PlacesService(dummyDiv);
    this.hasSelectedPlace = this.initialValue ? true : false;
  }

  onInput() {
    this.hasSelectedPlace = false;         // typing means not yet selected
    const request: google.maps.places.AutocompletionRequest = {
      input: this.searchQuery,
      componentRestrictions: { country: this.countryCode },
      ...(this.placeTypes?.length ? { types: this.placeTypes } : {})
    };
    this.autocompleteService.getPlacePredictions(request, (predictions, status) => {
      this.predictions = status === google.maps.places.PlacesServiceStatus.OK && predictions ? predictions : [];
    });
  }

  selectPlace(prediction: google.maps.places.AutocompletePrediction) {
    this.placesService.getDetails({ placeId: prediction.place_id }, (place, status) => {
      if (
        status === google.maps.places.PlacesServiceStatus.OK &&
        place?.geometry?.location
      ) {
        this.placeSelected.emit({
          name: place.name,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          fullAddress: place.formatted_address || '',
          address_components: place.address_components || []
        });
        this.predictions = [];
        this.searchQuery = place.name;
        this.hasSelectedPlace = true;
      } else {
        console.warn('Invalid place:', place);
        this.hasSelectedPlace = false;
      }
    });
  }

  // used for closing the drodpown, might be a better way
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInsideInput = target.closest('#citySearch');
    const clickedPrediction = target.closest('.prediction-item');

    if (!clickedInsideInput && !clickedPrediction) {
      this.predictions = [];
    }
  }
}
